const config = {
    API_BASE_URL: "https://api.getfasteducation.com",
    // API_BASE_URL: "http://localhost:5000",
};

export default config;
